import React from 'react'
import PropTypes from 'prop-types'
import { GridColumn, GridRow } from 'semantic-ui-react'
import RegisteredFormField from '../../common/RegisteredFormField'

const MedicationInputRow = ({ path, index, removeRow }) => {
  return <GridRow key={index}>
    <GridColumn width={16}>
      <h5>{`Medication (${index + 1})`}&nbsp;{removeRow && removeRow}</h5>
    </GridColumn>
    <GridColumn width={6}>
      <RegisteredFormField
        id={`applicantName-${index}`}
        label='Applicant Name'
        path={`${path}[${index}].applicantName`}
      />
    </GridColumn>
    <GridColumn width={8}>
      <RegisteredFormField
        id={`medicationName-${index}`}
        label='Medication Name (from prescription label)'
        path={`${path}[${index}].medicationName`}
      />
    </GridColumn>
    <GridColumn width={6}>
      <RegisteredFormField
        id={`dosage-${index}`}
        label='Dosage/Frequency'
        path={`${path}[${index}].dosage`} />
    </GridColumn>
    <GridColumn width={6}>
      <RegisteredFormField
        id={`datesTaken-${index}`}
        label='Dates Taken'
        path={`${path}[${index}].datesTaken`}
      />
    </GridColumn>
    <GridColumn width={10}>
      <RegisteredFormField
        id={`reasonForTaking-${index}`}
        label='Reason for Taking'
        path={`${path}[${index}].reasonForTaking`}
      />
    </GridColumn>
  </GridRow>
}

MedicationInputRow.propTypes = {
  /** Redux store object root path */
  path: PropTypes.string.isRequired,
  /** The array index for this form object */
  index: PropTypes.number.isRequired,
  /** A button to render, that when clicked, removes the object at specified index */
  removeRow: PropTypes.object
}

export default MedicationInputRow